import { useNavigate } from "react-router-dom";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { pageRoutes } from "../../constants";
import { submitButtonSx } from "../../components/Auth/common";

// Shown instead of the registration form while the invitation in the link is checked, and when it can't be used
// (error): expired, already used, or the person already has an account
export default function InvitationNotice({ isChecking, error }) {
  const navigate = useNavigate();

  if (isChecking) {
    return (
      <Box sx={{ py: 4 }} role="status">
        <CircularProgress />
        <Typography sx={{ mt: 2, color: "text.secondary" }}>Checking your invitation…</Typography>
      </Box>
    );
  }

  return (
    <>
      <Typography variant="h5" fontWeight="600" sx={{ mb: 2, color: "primary.main" }}>
        This invitation can’t be used
      </Typography>

      <Typography role="alert" sx={{ color: "text.secondary" }}>
        {error}
      </Typography>

      <Button fullWidth variant="contained" onClick={() => navigate(pageRoutes.LOGIN)} sx={submitButtonSx}>
        Go to login
      </Button>
      <Button fullWidth onClick={() => navigate(pageRoutes.REGISTER)} sx={{ mt: 1, textTransform: "none" }}>
        Register without an invitation
      </Button>
    </>
  );
}
